import { quoteKpis, quotePeriodStart } from "./quote-kpis";

const sentStatuses = new Set(["sent", "accepted", "declined"]);
const closedStatuses = new Set([...sentStatuses, "cancelled"]);

export function parseQuoteDate(value) {
  if (!value) return null;
  const raw = String(value);
  const date = new Date(raw.includes(" ") ? `${raw.replace(" ", "T")}Z` : raw);
  return Number.isNaN(date.getTime()) ? null : date;
}

export function procurementDashboardData(items, period = "month", now = new Date()) {
  const start = quotePeriodStart(period, now);
  const inPeriod = (value) => {
    const date = parseQuoteDate(value);
    return Boolean(date && date >= start && date <= now);
  };
  const kpis = quoteKpis(items, period, now);
  const pending = items.filter((item) => !item.proposalSentAt && !closedStatuses.has(item.status));
  const createdInPeriod = items.filter((item) => inPeriod(item.createdAt));
  const sentInPeriod = items.filter((item) =>
    (item.proposalSentAt || sentStatuses.has(item.status)) &&
    inPeriod(item.proposalSentAt || item.updatedAt),
  );
  const days = period === "day" ? 1 : period === "week" ? 7 :
    period === "month" ? Math.ceil((now - start) / 86400000) + 1 : 12;
  const buckets = Array.from({ length: days }, (_, index) => {
    const date = new Date(start);
    if (period === "year") date.setMonth(index);
    else date.setDate(date.getDate() + index);
    const key = period === "year"
      ? `${date.getFullYear()}-${date.getMonth()}`
      : `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`;
    const label = period === "year"
      ? date.toLocaleDateString("pt-BR", { month: "short" }).replace(".", "")
      : date.toLocaleDateString("pt-BR", { day: "2-digit", month: "2-digit" });
    return { key, label, received: 0, sent: 0 };
  });
  const keyFor = (value) => {
    const date = parseQuoteDate(value);
    return date && (period === "year"
      ? `${date.getFullYear()}-${date.getMonth()}`
      : `${date.getFullYear()}-${date.getMonth()}-${date.getDate()}`);
  };
  for (const item of createdInPeriod) {
    const bucket = buckets.find((entry) => entry.key === keyFor(item.createdAt));
    if (bucket) bucket.received++;
  }
  for (const item of sentInPeriod) {
    const bucket = buckets.find((entry) => entry.key === keyFor(item.proposalSentAt || item.updatedAt));
    if (bucket) bucket.sent++;
  }
  const stages = [
    { label: "Novas e em análise", value: pending.filter((item) => ["new", "under_review"].includes(item.status)).length, color: "#4f77ec" },
    { label: "Vistoria", value: pending.filter((item) => ["inspection_pending", "inspection_scheduled"].includes(item.status)).length, color: "#8b6ce9" },
    { label: "Em preparação", value: pending.filter((item) => !["new", "under_review", "inspection_pending", "inspection_scheduled"].includes(item.status)).length, color: "#efa847" },
    { label: "Enviadas no período", value: sentInPeriod.length, color: "#29ad83" },
  ];
  const clients = Object.values(createdInPeriod.reduce((acc, item) => {
    const name = item.clientName || "Cliente não informado";
    if (!acc[name]) acc[name] = { name, value: 0 };
    acc[name].value++;
    return acc;
  }, {})).sort((a, b) => b.value - a.value).slice(0, 5);
  return { ...kpis, pending: pending.length, clientCount: new Set(createdInPeriod.map((item) => item.clientId || item.clientName)).size, buckets, stages, clients,
    latestPending: [...pending].sort((a, b) => (parseQuoteDate(b.createdAt) || 0) - (parseQuoteDate(a.createdAt) || 0)).slice(0, 5) };
}
